<template>
  <div class="container is-uppercase has-text-weight-bold">
    <Header/>
    <div class="section">
      <h1 class="title">{{ 'Profile' | translate }}</h1>
      <h2 class="subtitle">{{ 'Settings' | translate }}</h2>
      <div class="columns is-mobile">
        <p class="column is-narrow profile-column">{{ 'Surname' | translate }}</p>
        <p class="column">
          <input type="text" class="input" v-model="profile.surname" />
        </p>
      </div>
      <div class="columns is-mobile">
        <p class="column is-narrow profile-column">{{ 'Lastname' | translate }}</p>
        <p class="column">
          <input type="text" class="input" v-model="profile.lastname" />
        </p>
      </div>
      <div class="columns is-mobile">
        <p class="column is-narrow profile-column">{{ 'Sex' | translate }}</p>
        <p class="column select">
          <select v-model="profile.sex">
            <option value="Woman">{{ 'Woman' | translate }}</option>
            <option value="Man">{{ 'Man' | translate }}</option>
          </select>
        </p>
      </div>
      <div class="columns is-mobile">
        <p class="column is-narrow profile-column">{{ 'Age' | translate }}</p>
        <p class="column">
          <input type="number" class="input" v-model="profile.age" />
        </p>
      </div>
      <div class="columns is-mobile">
        <p class="column is-narrow profile-column">{{ 'Height' | translate }} (cm)</p>
        <p class="column">
          <input type="number" class="input" v-model="profile.height" />
        </p>
      </div>
      <div class="columns is-mobile">
        <p class="column is-narrow profile-column">{{ 'Weight' | translate }} (kg)</p>
        <p class="column">
          <input type="number" class="input" v-model="profile.weight" />
        </p>
      </div>
      <div class="columns is-mobile">
        <p class="column is-narrow profile-column">{{ 'Body' | translate }}</p>
        <p class="column select">
          <select v-model="profile.body">
            <option value="Skinny">{{ 'Skinny' | translate }}</option>
            <option value="Average">{{ 'Average' | translate }}</option>
            <option value="Corpulent">{{ 'Corpulent' | translate }}</option>
            <option value="Muscular">{{ 'Muscular' | translate }}</option>
          </select>
        </p>
      </div>
      <div class="columns is-mobile">
        <p class="column is-narrow profile-column">{{ 'Goal' | translate }}</p>
        <p class="column select">
          <select v-model="profile.goal">
            <option value="Health">{{ 'Health' | translate }}</option>
            <option value="Endurance">{{ 'Endurance' | translate }}</option>
            <option value="Appearance">{{ 'Appearance' | translate }}</option>
            <option value="Strength">{{ 'Strength' | translate }}</option>
          </select>
        </p>
      </div>
      <div>
        <a :class="'link is-size-5 ' + ($store.isMH ? 'has-text-grey-darker' : 'has-text-white')" @click="updateProfile">{{ 'Save' | translate }}</a>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'Profile',
  data () {
    return {
      profile: this.$store.getters.getProfile
    }
  },
  methods: {
    updateProfile () {
      this.profile.age = parseInt(this.profile.age)
      this.profile.height = parseInt(this.profile.height)
      this.profile.weight = parseInt(this.profile.weight)
      this.$store.dispatch('updateProfile', this.profile)
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
.profile-column {
  width: 10rem;
}
</style>




// WEBPACK FOOTER //
// src/components/Settings/Profile.vue